import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import './SearchInput.scss'

type Props = {
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function SearchInput({ value, onChange }: Props) {
  return (
    <div className="home-search">
      <SearchOutlined className="home-search__icon" />
      <input
        className="home-search__input"
        value={value}
        onChange={onChange}
        placeholder="Search songs, albums, artists, podcasts"
      />
    </div>
  )
}

export default SearchInput
